"use client";

import { c as _c } from "react/compiler-runtime";
import { MessageSquare, Heart, Star } from "lucide-react";
interface DiscussionStatsProps {
  postsMade: number;
  reactionCount: number;
  totalPoints: number;
  labels: Record<string, string>;
}
export default function DiscussionStats(t0) {
  const $ = _c(26);
  const {
    postsMade,
    reactionCount,
    totalPoints,
    labels
  } = t0;
  const t1 = labels.postsMade;
  let t2;
  if ($[0] !== postsMade) {
    t2 = postsMade.toLocaleString();
    $[0] = postsMade;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== labels.postsMade || $[3] !== t2) {
    t3 = {
      icon: MessageSquare,
      label: t1,
      value: t2,
      color: "text-primary"
    };
    $[2] = labels.postsMade;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = labels.reactionsReceived;
  let t5;
  if ($[5] !== reactionCount) {
    t5 = reactionCount.toLocaleString();
    $[5] = reactionCount;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== labels.reactionsReceived || $[8] !== t5) {
    t6 = {
      icon: Heart,
      label: t4,
      value: t5,
      color: "text-rose-500"
    };
    $[7] = labels.reactionsReceived;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = labels.discussionPoints;
  let t8;
  if ($[10] !== totalPoints) {
    t8 = totalPoints.toLocaleString();
    $[10] = totalPoints;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== labels.discussionPoints || $[13] !== t8) {
    t9 = {
      icon: Star,
      label: t7,
      value: t8,
      color: "text-amber-500"
    };
    $[12] = labels.discussionPoints;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t6 || $[17] !== t9) {
    t10 = [t3, t6, t9];
    $[15] = t3;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const stats = t10;
  let t11;
  if ($[19] !== labels.discussionStats) {
    t11 = <h2 className="mb-4 text-lg font-semibold text-foreground">{labels.discussionStats}</h2>;
    $[19] = labels.discussionStats;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== stats) {
    t12 = <div className="grid grid-cols-3 gap-4">{stats.map(_temp)}</div>;
    $[21] = stats;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
function _temp(stat) {
  return <div key={stat.label} className="rounded-lg border border-border bg-card p-4"><div className="mb-2 flex items-center gap-2"><stat.icon className={`h-5 w-5 ${stat.color}`} /><span className="text-sm text-muted-foreground">{stat.label}</span></div><p className="text-2xl font-bold text-foreground">{stat.value}</p></div>;
}